<router-outlet (activate)="onActivate($event, outlet)" #outlet>
    <app-spinner></app-spinner>
</router-outlet>